import { CategoryId, CategoryResponse } from '@business/entities/category';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { R } from '@core/utils/r';
import { RegionId } from '@business/entities/tm';

export function fetchCategories(withTrashed, regionId?: RegionId) {
  const params = R.objectCompact({ withTrashed, regionId });
  return Endpoint.get<CategoryResponse[]>(`@gc/category`, { params });
}

export function fetchCategory(id: CategoryId) {
  return Endpoint.get<CategoryResponse>(`@gc/category/category/${id}`);
}

export function createCategory(data: Partial<CategoryResponse & { canUpdateTemplate: boolean }>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<CategoryResponse>(`@gc/category`, { formData, hasFiles: true });
}

export function updateCategory(id: CategoryId, data: Partial<CategoryResponse & { canUpdateTemplate: boolean }>) {
  return Endpoint.patch<CategoryResponse>(`@gc/category/${id}`, { data });
}

export function deleteCategory(id: CategoryId) {
  return Endpoint.delete<void>(`@gc/category/${id}`);
}

export function syncCategories() {
  return Endpoint.get<CategoryResponse[]>(`@gc/category/sync`);
}

export function sortCategories(ids: CategoryId[], parentCatId?: CategoryId) {
  return Endpoint.post<CategoryResponse[]>(`@gc/category/sort`, { data: { ids, parentCatId } });
}
